enum Mutation {
  REMOVE_ABSENCE = 'removeAbsence',
  SET_ABSENCE = 'setAbsence',
}

export default Mutation;
